module.exports = __webpack_public_path__ + "media/images/og_image-5d54b75e8b4b980a2026405a30085ef5.png";